export default {"src":"/_next/static/media/pen-book.1679947d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};